import { Accordion } from '@whistler-ui/k2/components/Accordion';
import { useClassHelper } from '@whistler-ui/k2/hooks';
import { useTranslation } from 'react-i18next';

import { TEST_STATUSES } from '../../../constants';
import { ExecutionTest, TTestTabs } from '../../../types';
import { TestConsolePane } from '../../TestConsolePane';
import { componentName } from '../constants';

interface Props {
  activeContent: TTestTabs;
  executions: ExecutionTest[];
}

export const Consoles = ({ executions, activeContent }: Props) => {
  const { t } = useTranslation();
  const c = useClassHelper(componentName);

  const [execution] = executions;

  const id = `${componentName}-${activeContent}-${execution.id}`;
  const isUseCaseExecutionId = Boolean(execution?.use_case_test_execution_id);

  if (isUseCaseExecutionId) {
    return executions.map(currentExecution => {
      return currentExecution.invocations.map(
        (invocation: any, index: number) => {
          return (
            <Accordion
              key={`${currentExecution.id}_${index}`}
              defaultOpen={index === 0}
              theme={`${
                invocation.status === TEST_STATUSES.FAILED ? 'odd' : 'even'
              }`}
            >
              <Accordion.Header>
                <div
                  className={c(
                    '__console_header',
                    `__console_header--${invocation.status}`,
                  )}
                >
                  <span>{t(currentExecution.api_tag)}</span>
                  <span className={c('__console-status')}>
                    {invocation.status}
                  </span>
                </div>
              </Accordion.Header>
              <Accordion.Content>
                <TestConsolePane
                  error={invocation.error}
                  request={invocation.request}
                  response={invocation.response}
                  id={`${invocation.id}`}
                />
              </Accordion.Content>
            </Accordion>
          );
        },
      );
    });
  }

  return (
    <div key={id} id={id}>
      {execution.invocations.map((invocation, index) => {
        return (
          <div key={`test_console_${index}`}>
            <TestConsolePane
              error={invocation.error}
              request={invocation.request}
              response={invocation.response}
              id={`${invocation.id}`}
            />
          </div>
        );
      })}
    </div>
  );
};
